import { cognitoConfig } from "@src/appV2/Auth/cognito/config";

interface CognitoLocalStorageState {
  cognitoKeyCount: number;
  hasRefreshToken: boolean;
  hasIdToken: boolean;
  hasAccessToken: boolean;
  hasLastAuthUser: boolean;
  lastAuthUser: string | undefined;
  isLocalStorageAccessible: boolean;
  [key: string]: unknown;
}

/**
 * Inspects localStorage for Cognito-related keys to diagnose token refresh failures.
 * Never logs token values — only reports presence/absence.
 */
export function getCognitoLocalStorageState(): CognitoLocalStorageState {
  try {
    const keyPrefix = `CognitoIdentityServiceProvider.${cognitoConfig.clientId}`;
    let cognitoKeyCount = 0;
    let hasRefreshToken = false;
    let hasIdToken = false;
    let hasAccessToken = false;
    let hasLastAuthUser = false;
    let lastAuthUser: string | undefined;

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key?.startsWith(keyPrefix)) {
        continue;
      }

      cognitoKeyCount++;

      if (key.endsWith(".refreshToken")) {
        hasRefreshToken = true;
      } else if (key.endsWith(".idToken")) {
        hasIdToken = true;
      } else if (key.endsWith(".accessToken")) {
        hasAccessToken = true;
      } else if (key.endsWith("LastAuthUser")) {
        hasLastAuthUser = true;
        lastAuthUser = localStorage.getItem(key) ?? undefined;
      }
    }

    return {
      cognitoKeyCount,
      hasRefreshToken,
      hasIdToken,
      hasAccessToken,
      hasLastAuthUser,
      lastAuthUser,
      isLocalStorageAccessible: true,
    };
  } catch {
    return {
      cognitoKeyCount: 0,
      hasRefreshToken: false,
      hasIdToken: false,
      hasAccessToken: false,
      hasLastAuthUser: false,
      lastAuthUser: undefined,
      isLocalStorageAccessible: false,
    };
  }
}
